export default "__VITE_ASSET__e48ddc57__"